<template>
  <div>
    <vue-element-loading
      is-full-screen
      :active="loading"
      spinner="bar-fade-scale"
      color="#152d51"
    />
    <div class="navbar w-100" style="background-color: #23409a; color: white">
      <h3 class="w-100 text-center my-3">ประกาศความเป็นส่วนตัว</h3>
    </div>
    <div
      class="w-100"
      :style="`height: ${!read ? 'calc(100vh - 104px)' : '100vh'}; overflow: auto`"
    >
      <div class="p-3 p-sm-4">
        <div class="mt-5" v-html="htmlData.htmlBody"></div>
        <v-checkbox
          v-if="!read"
          style="color: #23409a !important"
          class="mt-3"
          v-model="checkbox"
          label="ข้าพเจ้ายินยอมในประกาศความเป็นส่วนตัว"
        ></v-checkbox>
      </div>
    </div>
    <div v-if="!read" class="w-100 bot-regis flex-all-center">
      <v-btn
        @click="summitPdpaHpmc"
        :disabled="!checkbox"
        class="col-8 main-btn"
        style="color: white"
        color="#23409A"
        >ยินยอม</v-btn
      >
    </div>
  </div>
</template>

<script>
import consendApi from '@/api/consend'
import config from '@/config'
import VueElementLoading from 'vue-element-loading'
import { mapGetters } from 'vuex'

export default {
  props: {
    read: {
      default: false
    },
    fetchApi: {
      default: true
    }
  },
  components: { VueElementLoading },
  data() {
    return {
      loading: false,
      checkbox: false,
      htmlData: ''
    }
  },
  async mounted() {
    const configApi = {
      params: {
        company: 'NCAP',
        product: 'HP-MC',
        template_id: 'Consent_PDPA_HPMC',
        page_id: config.pageid
      }
    }
    try {
      this.loading = true
      const response = await consendApi.getConsendTemplateV2(configApi)
      this.htmlData = response.data.data
    } catch (error) {
      console.error(error)
      this.$swal.fire({
        type: 'error',
        text: 'โหลดประกาศความเป็นส่วนตัวไม่สำเร็จ'
      })
    } finally {
      this.loading = false
    }
  },
  methods: {
    async summitPdpaHpmc() {
      if (!this.htmlData || !this.htmlData.version) {
        this.$swal.fire({
          type: 'error',
          text: 'เกิดข้อผิดพลาดไม่พบ version pdpa'
        })
        return
      }
      if (!this.profile || !this.profile.displayName || !this.profile.userId) {
        this.$swal.fire({
          type: 'error',
          text: 'เกิดข้อผิดพลาดไม่พบข้อมูลผู้ใช้'
        })
        return
      }
      if (!this.fetchApi) {
        let tempData = this.regisList
        tempData.version.hpmc = this.htmlData.version
        tempData.answer.hpmc = 'Y'
        this.$store.dispatch('setRegisList', tempData)
        this.$emit('next')
        return
      }
      try {
        this.loading = true
        await consendApi.postUserConsendV2({
          body: {
            page_id: config.pageid,
            next_body: [
              {
                ConsentType: 'Consent_PDPA_HPMC',
                lineName: this.profile.displayName,
                userId: this.profile.userId,
                version: this.htmlData.version,
                companyKey: 'NCAP',
                ConsentItemId: 'HPMC',
                answer: 'Y'
              }
            ]
          },
          config: {}
        })
        this.$emit('next')
      } catch (error) {
        this.$swal.fire({
          type: 'error',
          text: 'เกิดข้อผิดพลาด'
        })
      } finally {
        this.loading = false
      }
    }
  },
  computed: {
    ...mapGetters(['regisList']),
    query() {
      return this.$store.state.query
    },
    view() {
      return this.$store.state.query.view
    },
    profile() {
      return this.$store.state.profile
    },
    userId() {
      return this.$store.getters.getUserid
    }
  }
}
</script>

<style lang="scss" scoped>
.MsoNormalTable {
  tr,
  td {
    border: 1px solid #454545;
  }
}
</style>
